// extracted by mini-css-extract-plugin
export default {"timeWeekSummaryDay":"TimeWeekSummaryDay_timeWeekSummaryDay__3Bxox","timeWeekSummaryDayRow":"TimeWeekSummaryDay_timeWeekSummaryDayRow__bwjov"};